import { render, staticRenderFns } from "./recoverRetrieveReportHis.vue?vue&type=template&id=d6c21bd4&scoped=true"
import script from "./recoverRetrieveReportHis.vue?vue&type=script&lang=js"
export * from "./recoverRetrieveReportHis.vue?vue&type=script&lang=js"
import style0 from "./recoverRetrieveReportHis.vue?vue&type=style&index=0&id=d6c21bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c21bd4",
  null
  
)

export default component.exports